<template>
  <action-dispatcher action="product/getProduct" :parameters="$route.params.id">
    <view-container
      class="view-product-modules"
      title="Avaliação final"
      subtitle=""
      header
      :breadcrumbs="breadcrumbs"
      contentHeader
    >
      <template #header>
        <div class="d-flex flex-row align-items-center justify-content-between">
          <product-dropdown v-if="product" :product="product" />
          <button
            v-if="product && product.is_blitz_members"
            class="btn btn-40 btn-link btn-new-link"
            @click="openClubLogged"
          >
            Acessar área de membros
            <i
              class="ml-5 fa-solid fa-arrow-up-right-from-square font-weight-bold"
            ></i>
          </button>
        </div>
      </template>
      <div class="view-member-area-modules-add-final-quizz pb-9">
        <div class="row">
          <aside class="view-content-aside col-lg-3 d-none d-lg-block">
            <steps
              :step="currentStep"
              :names="steps"
              @change-step="changeStep"
            />
          </aside>
          <div class="col-12 d-lg-none">
            <steps
              :step="currentStep"
              :names="steps"
              @change-step="changeStep"
            />
          </div>
          <form-quizz-basic-info
            v-if="currentStep === 1"
            class="col-lg-9"
            is-final
            :form="form"
            :errors="errors"
            :loading="loading"
            @next="next"
            @cancel="cancel"
          />
          <form-quizz-questions
            v-if="currentStep === 2"
            class="col-lg-9"
            is-final
            :form="form"
            v-model="form"
            :errors="errors"
            :loading="loading"
            @update="dispatch"
            @save="save"
            @previous="previous"
            is-final-quiz
          />
        </div>
      </div>
    </view-container>
  </action-dispatcher>
</template>

<script>
import FormQuizzBasicInfo from "@/components/product/details/content/modules/quizz/FormQuizzBasicInfo";
import FormQuizzQuestions from "@/components/product/details/content/modules/quizz/FormQuizzQuestions";
import ProductDropdown from "@/components/product/ProductDropdown.vue";
import ViewContainer from "@/components/ViewContainer.vue";
import { TRANSLATE_FIELD_QUIZZ_MAP } from "@/constants/fields.js";
import {
  formFields,
  is_valid_br_date_str,
  removeTimeZone
} from "@/functions/helpers";
import MemberAreaMixin from "@/mixins/memberArea.js";
import ProductActionsMixin from "@/mixins/productActions.js";
import moment from "moment";
import { mapState } from "vuex";

export default {
  mixins: [ProductActionsMixin, MemberAreaMixin],
  components: {
    FormQuizzQuestions,
    FormQuizzBasicInfo,
    ProductDropdown,
    ViewContainer
  },
  mounted() {
    this.dispatch();
  },
  data() {
    return {
      ...formFields(
        [
          "id",
          "title",
          "description",
          "time_limit_minutes",
          "approval_average",
          "allow_reveal_answer_keys",
          "number_of_attempts",
          "release_at",
          "days_to_release",
          "release_final_quiz_when_finished",
          "questions"
        ],
        {
          release_final_quiz_when_finished: false,
          questions: [],
          time_limit_minutes: 0,
          approval_average: 0,
          allow_reveal_answer_keys: false,
          number_of_attempts: 0
        }
      ),
      currentStep: 1,
      loading: false
    };
  },
  computed: {
    ...mapState("product", ["product"]),
    steps() {
      return ["Informações básicas", "Questões"];
    },
    breadcrumbs() {
      return [
        { link: "product", title: "Meus produtos" },
        {
          link: "product-details",
          title: this.product ? this.product["name"] : "...",
          params: { id: this.$route.params.id }
        },
        {
          link: "product-member-area-modules",
          title: "Conteúdo",
          params: { id: this.$route.params.id }
        },
        {
          title: "Prova Final"
        }
      ];
    },
    question_without_right_answer() {
      if (this.form.questions.length) {
        return this.form.questions.findIndex(
          q =>
            !q.answer_options
              .filter(a => !a.deleted)
              .reduce((acc, curr) => acc || curr.is_right_answer, false)
        );
      }

      return -1;
    },
    question_without_title() {
      if (this.form.questions.length) {
        return this.form.questions.findIndex(q =>
          q.answer_options
            .filter(a => !a.deleted)
            .reduce((acc, curr) => acc || `${curr.title}`.length == 0, false)
        );
      }

      return -1;
    }
  },
  methods: {
    dispatch() {
      if (this.$route.params.id) {
        this.$store
          .dispatch("membersQuizzes/getQuizzFinal", this.$route.params.id)
          .then(data => {
            if (data && data.final_quiz) {
              const past_release_at = data.final_quiz.release_at
                ? {
                    release_at: new Date(
                      removeTimeZone(data.final_quiz.release_at)
                    ).toLocaleDateString()
                  }
                : {};
              const number_of_attempts =
                data.final_quiz.number_of_attempts > 0
                  ? Number(data.final_quiz.number_of_attempts) - 1
                  : 0;
              this.form = {
                ...data.final_quiz,
                ...past_release_at,
                number_of_attempts,
                release_final_quiz_when_finished:
                  data.release_final_quiz_when_finished
              };
            }
          })
          .catch(e => {});
      }
    },
    changeStep(step) {
      this.currentStep = step;
    },
    next() {
      this.changeStep(this.currentStep + 1);
    },
    previous() {
      this.changeStep(this.currentStep - 1);
    },
    cancel() {
      this.$router.go(-1);
    },
    build_payload(form) {
      const payload = { ...form };
      for (let k in payload.questions) {
        const alternatives = [...payload.questions[k].answer_options];
        for (let i in alternatives) {
          if (
            alternatives[i].id &&
            `${alternatives[i].id}`.indexOf("local-alt") > -1
          ) {
            delete alternatives[i].id;
          }
        }

        payload.questions[k].answer_options = alternatives;
      }

      let release_at = form.release_at || null;
      if (form.release_at && form.release_at.length == 10) {
        release_at = moment(form.release_at, "DD/MM/YYYY").toISOString();
      }

      if (Object.keys(payload).includes("module_id")) {
        delete payload.module_id;
      }

      return { ...payload, release_at };
    },
    save() {
      if (this.loading) return;

      if (!this.form.title || !this.form.title.length) {
        this.$message.warning(
          "Preencha o título da avaliação antes de salvar."
        );
        return;
      }

      if (!this.form.description || !this.form.description.length) {
        this.$message.warning(
          "Preencha as orientações para a avaliação antes de salvar."
        );
        return;
      }

      if (this.form.description.length > 1000) {
        this.$message.warning(
          "A orientação para a avaliação deve ter até 1000 caractéres"
        );
        return;
      }

      if (
        this.form.release_at &&
        this.form.release_at.length > 0 &&
        !is_valid_br_date_str(this.form.release_at)
      ) {
        this.$message.warning(
          "Digite uma data válida para liberação da avaliação em uma data específica"
        );
        return;
      }

      if (this.question_without_right_answer > -1) {
        this.$message.warning(
          `Por favor, indique a resposta correta da questão ${this
            .question_without_right_answer + 1}`
        );
        return;
      }

      if (this.question_without_title > -1) {
        this.$message.warning(
          `Por favor, há pelo menos uma alternativa sem texto definido na questão: ${this
            .question_without_title + 1}`
        );
        return;
      }

      let final_quiz = this.build_payload({
        ...this.form,
        number_of_attempts: Number(this.form.number_of_attempts) + 1,
        product_id: this.$route.params.id
      });

      let action = "membersQuizzes/postFinal";
      if (final_quiz.id) {
        action = "membersQuizzes/putFinal";
      }

      this.loading = true;

      this.$store
        .dispatch(action, {
          final_quiz,
          product_id: this.$route.params.id,
          release_final_quiz_when_finished: this.form
            .release_final_quiz_when_finished
        })
        .then(() => {
          this.$message.success("A avaliação foi salva com sucesso!");
          this.$router.push({
            name: "product-member-area-modules",
            params: {
              id: this.$route.params.id
            }
          });
        })
        .catch(e => {
          let msg = get_error_msg(
            e.response.data.final_quiz,
            TRANSLATE_FIELD_QUIZZ_MAP,
            `Erro ao salvar a avaliação`
          );
          this.$message.error(msg);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    deleteQuestion() {
      this.loading = true;
      this.$store
        .dispatch("membersQuizzes/putFinal", this.form)
        .then(response => {
          this.$message.success("A questão deletada foi deletada");
          this.dispatch();
        })
        .catch(e => {
          this.$message.error("Erro ao deletar a questão");
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.view-member-area-modules-add-final-quizz {
  a {
    text-decoration: none;
  }

  .title {
    font-size: 16px;
    color: #3b3b4ae5;
    font-weight: normal;
    margin-bottom: 0px;
    @media screen and (max-width: 991px) {
      font-size: 14px;
    }
  }
  .description {
    font-size: 12px;
    color: #77788edd;
  }

  .btn {
    white-space: nowrap;
  }

  .info-wrapper {
    color: #57586be0;
    font-family: "Noto Sans";
  }

  .btn {
    .icon-angle-right {
      font-size: 20px;
    }
  }
}
</style>
